import { Space } from 'antd';
import PropTypes from 'prop-types';
import { CheckboxSummary, TitleSummary } from '../../style';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';

export const CheckboxComponent = ({ field }) => {
  const { translate: t } = useDictionaryTranslation();
  return (
    <>
      <TitleSummary level={5}>{field.label}</TitleSummary>
      <Space key={field.idInput} direction="horizontal">
        <CheckboxSummary defaultChecked={field.value} disabled>
          <p>{t('yes')}</p>
        </CheckboxSummary>
        {field.value ? (
          <CheckboxSummary disabled>
            <p>{t('no')}</p>
          </CheckboxSummary>
        ) : null}
      </Space>
    </>
  );
};

CheckboxComponent.propTypes = {
  field: PropTypes.object.isRequired,
};
